export default __webpack_public_path__ + "static/media/c_3.beeaaf18.JPG";